import { LABELS } from 'components/properties/constants'
import { getLocalizedLabels } from 'services'

export const usePropertyLabels = () => {
  return getLocalizedLabels(LABELS)
}
